import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import ProvinceModalContainer from '../../components/SetupSubPageComps/ProvincesComps/ProvinceModalContainer';
import ShowAllProvinces from '../../components/SetupSubPageComps/ProvincesComps/ShowAllProvinces';
import ProvinceProvider from '../../contexts/ProvinceProvider';

const Provinces = () => {
  // rendering provinces page component here
  return (
    <>
      <PageTitle title='Provinces' />

      <ProvinceProvider>
        <ShowAllProvinces />
        <ProvinceModalContainer />
      </ProvinceProvider>
    </>
  );
};

export default Provinces;
